import { Component } from '@angular/core';

@Component({
    selector: 'app-privacy-policy-31-july-2024',
    templateUrl: './privacy-policy-31-july-2024.component.html',
    styleUrl: './privacy-policy-31-july-2024.component.scss',
    standalone: false
})
export class PrivacyPolicy31July2024Component {

}
